var $ = require('jquery')

//XXX: Require require('jquery.transit')

module.exports = function (options) {
  // Keep in sync with `(.mod-summary p)'s line-height and padding-bottom`
  //   if need to change these values
  var lineHeight = options.lineHeight,
    maxColumns = options.maxColumns,
    MAX_HEIGHT = lineHeight * maxColumns,
    EXPANDED_CLASS = 'mod-summary-ex',
    modSummary = $('.mod-summary'),
    modSummaryTextbox = modSummary.find('.text-box'),
    contentHeight = modSummaryTextbox.find('.text-box-in').height(),
    modSummaryOffsetTop = modSummary.offset().top

  if (contentHeight > MAX_HEIGHT) {
    modSummary.append(
      $(options.moreBtnTmpl)
    )
  } else {
    modSummaryTextbox.css('height', 'auto')
    return
  }

  function expandAndFoldSummaryFull() {
    var el = $(this),
      beExpand = !modSummary.hasClass(EXPANDED_CLASS)

    modSummary.toggleClass(EXPANDED_CLASS, beExpand)

    el.find('.label')
      .text(beExpand ? options.expandLabel : options.collapseLabel)

    modSummaryTextbox
      .animate({
        height: beExpand ? contentHeight : MAX_HEIGHT
      }, 'fast', function () {
        if (beExpand) {
          return
        }
        if (modSummary[0].getBoundingClientRect().top > 0) {
          return
        }
        var OFFSET = 50
        window.scroll(0, modSummaryOffsetTop - OFFSET)
      })
  }

  modSummary.on('click', '.bt-more', expandAndFoldSummaryFull)

};